/* eslint-disable react/destructuring-assignment */
import Section1 from '@/components/RoutePage/SectionManager/Section1';
import React from 'react';

function SectionCompareAirline(props: any) {
  return (
    <Section1
      {...props}
      flightData={props.allAirlineFlightData}
      days={props.allAirlineDays}
    />
  );
}

export default React.memo(SectionCompareAirline);
